"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_ONBOARDING_STEPS = exports.ONBOARDING_OWNER_STEPS = exports.ONBOARDING_ADVERTISER_STEPS = void 0;
exports.ONBOARDING_ADVERTISER_STEPS = [
    "LAUNCH_FIRST_CAMPAIGN",
    "CHOOSE_AD_PLACEMENT",
    "EXPLORE_MAP",
    "GROUP_SCREENS",
    "SAVE_SCREEN_SETS",
    "UPLOAD_MEDIA",
    "REVIEW_AND_PAY",
    "COMPLETE_PAYMENT",
    "TRACK_CAMPAIGN_STATUS",
];
exports.ONBOARDING_OWNER_STEPS = [
    "CONNECT_FIRST_SCREEN",
    "REGISTER_SCREEN",
    "COMPLETE_BUSINESS_DATA",
    "GO_TO_BUSINESS_DATA",
    "ENABLE_MONETIZATION",
    "CONNECT_STRIPE",
    "DISCOVER_INVENTORY",
    "INVENTORY_TOUR",
    "SEND_FIRST_CONTENT",
    "QUICK_SUBMISSION",
    "MANAGE_CAMPAIGNS",
    "VIEW_CAMPAIGNS",
    "CHECK_WALLET",
    "GO_TO_WALLET",
];
exports.ALL_ONBOARDING_STEPS = [
    ...exports.ONBOARDING_ADVERTISER_STEPS,
    ...exports.ONBOARDING_OWNER_STEPS,
];
